import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <table className="ilead_v_sport	people_active tablesrink"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1 " align="left"
                                                        valign="top" width="50%">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <textarea rows="5"
                                                                  cols="100"
                                                                  style={{width:'99%'}}
                                                                  name="answer1"
                                                                  value={this.props.pageData?.answer1}
                                                                  onChange={this.props.handleChangeTextarea}/>

                                                    </td>

                                                </tr>

                                                </tbody>
                                            </table>


                                            <ul className="greenbullet-list"
                                                style={{marginBottom:'11px !important',marginTop:'11px !important'}}>
                                                <li>What came out of this experience that turned out to be
                                                    good?
                                                </li>
                                                <li>What did you learn from the experience that has stood you in
                                                    good stead for the future?
                                                </li>
                                            </ul>
                                            <table className="ilead_v_sport	people_active tablesrink"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1 " align="left"
                                                        valign="top" width="50%">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                         <textarea rows="5"
                                                                   cols="100"
                                                                   style={{width:'99%'}}
                                                                   name="answer2"
                                                                   value={this.props.pageData?.answer2}
                                                                   onChange={this.props.handleChangeTextarea}/>
                                                    </td>

                                                </tr>

                                                </tbody>
                                            </table>


                                            <p>
                                                Thinking about the choices you have made objectively, and
                                                whether you would choose differently
                                                now, helps you identify factors you hadn’t considered before. It
                                                will help you relax about possible
                                                future setbacks, knowing that there is usually more than one way
                                                to achieve things – and that the
                                                first time you encounter a difficulty, it doesn’t mean you’ve
                                                failed.
                                            </p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>THE ZIG ZAG EXERCISE
                                            </div>
                                            <div className="subtitle-table"><p>We are our own harshest critics.
                                                The Zig Zag technique<a className="superscripttext "
                                                                        href="further_info.php?course=300"><sup>3</sup></a> is
                                                designed to bolster your belief in
                                                yourself, by being your own devil’s advocate. The more you argue
                                                the case for believing in yourself
                                                and challenge your own negative self-talk, the more you defend
                                                and believe in your ‘cause.’</p></div>
                                            <div className="lightgreencontentbg keyquestionpad  ">
                                                <div className="border_subtitle">How the zig zag technique
                                                    works
                                                </div>

                                                <ol className="brownbullet-list listcontentSpacing">
                                                    <li><p>First box – write down in the top left hand box a
                                                        belief that you want to strengthen;
                                                        maybe, after a setback you want to re-establish your
                                                        confidence. Rate your
                                                        confidence in percentage on a scale of 1-100%.</p></li>
                                                    <li><p>In the next box down on the right, write your doubts,
                                                        reservations or challenges to
                                                        that belief in box 1.</p></li>
                                                    <li><p>In the next box dispute your attack and re-defend
                                                        your belief.</p></li>
                                                </ol>
                                            </div>
                                            <p>
                                                You can repeat steps 2 and 3 until you exhaust all your self
                                                criticisms. Be sure to address all the
                                                doubts that surfaced after your setback, and give a good
                                                argument for proving to yourself that
                                                there is a new, healthy and alternative way of thinking. Use as
                                                many forms as you need and be
                                                sure to stop while defending rather than attacking. If you can’t
                                                help finishing with a criticism, ask
                                                a friend to provide an alternative, final defence. It may be
                                                helpful to do this exercise with a mentor
                                                or line manager to demonstrate the reasons for your self-doubt
                                                and discuss training or other
                                                means to help you overcome it.
                                            </p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}